import { Box } from "@material-ui/core";
import React, { lazy, Suspense } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import ListingLayout from "../../Components/UI/ListingLayout";
import { useSelector } from "react-redux";

const ReviewPackages = lazy(() => import("../Promotion/Packages"));
const History = lazy(() => import("../Location/History"));

const PackageTabs = () => {
  const location = useLocation();
  const history = useHistory();
  const prepath = `/d/review/packages`;
  const { activeLocation } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );
  const paths = [
    {
      title: "Packages",
      path: `${prepath}`,
      item_name: "PACKAGES",
      path_to_match: `${prepath}`,
    },
    {
      title: "Order History",
      path: `${prepath}/order-history?location_id=${activeLocation?.id}`,
      item_name: "ORDERS",
      path_to_match: `${prepath}/order-history`,
    },
  ];

  return (
    <div>
      <ListingLayout
        title={`Review Packages`}
        mode={`Update`}
        pageName="Profile"
        parentLink="/"
        childLink="/"
        customTitle={``}
        showLocationToggle={
          location?.pathname?.includes("order-history") ? true : false
        }
        history={history}
        hidePageHeader={true}
        hideHeader={true}
        hideAdd={true}
        paths={paths}
        showProfileTabs={true}
        profileLocation={location}
      >
        <Box mb="1rem">
          <Suspense fallback={<></>}>
            <Switch>
              <Route
                exact
                path={`/d/review/packages`}
                render={() => <ReviewPackages />}
              />
              <Route
                exact
                path={`/d/review/packages/order-history`}
                render={() => <History />}
              />
            </Switch>
          </Suspense>
        </Box>
      </ListingLayout>
    </div>
  );
};

export default PackageTabs;
